/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Collection methods
 * -----------------------------------------------------------------------------
 *
 * @namespace collection
 */

import axios from 'axios';
import Flickity from 'flickity';
import detectIt from 'detect-it';

var createHistory = require('history').createBrowserHistory;

var history = createHistory();

var collectionMethods = {
  data: function data() {
    return {
      isCollectionAjaxed: false,
      collection: {
        title: null,
        description: null,
        image: null,
        handle: null,
        showProducts: false,
        showModal: false,
        products: [],
        pagination: {},
        activeFilters: [],
        compareProducts: [],
        outputProducts: []
      }
    };
  },


  methods: {
    _initCollection: function _initCollection() {
      var isCollectionAjaxed = $('[data-template="collection"]').data('collection-ajaxed');

      // stop parsing if we are not in the collection template
      if (app.currentTemplate !== 'collection') {
        return;
      }

      // check collection section settings => enable ajax filters
      if (isCollectionAjaxed) {
        app.isCollectionAjaxed = true;
      } else {
        app._getcollectionInfo();
      }

      app._initFilters();
      app.collection.compareProducts = [];
    },
    _showVariant: function _showVariant(event) {
      var value = event.currentTarget.value;
      var $carousel = $(event.currentTarget).closest('.card').find('[data-flickity]');

      if ($carousel.length > 0) {
        var flkty = Flickity.data($carousel[0]);
        var cellElements = flkty.getCellElements();

        cellElements.forEach(function (element, index) {
          var imgAlt = $(element).data('variant-title');
          if (imgAlt === value) {
            flkty.selectCell(index, true, false); // value, isWrapped, isInstant
          }
        });
      }
    },
    _initFilters: function _initFilters() {
      // const location = history.location;
      Shopify.queryParams = {};

      // Listen for changes to the current location
      history.listen(function (location, action) {
        // location is an object like window.location
        app._runFilters(); // run every time history changes
      });

      // run one time during 1st page load or upon page refresh
      app._runFilters();
    },
    _runFilters: function _runFilters() {
      app._urlParams();
      app._mapFilters();
      var url = app._filtersCreateUrl();

      if (app.isCollectionAjaxed) {
        app._getcollectionInfo();
        app._getCollFilteredProducts(url);
      }
    },


    /**
     * Event when an input filter changes
     *
     */
    _parseFilters: function _parseFilters(event) {
      var filterType = $(event.currentTarget).data('filter-type');
      var collectionHandle = $(event.currentTarget).data('handle');
      var selectedTags = [];

      // Collection filtering
      if (filterType === 'collection') {
        var newURL = '';
        var search = $.param(Shopify.queryParams);
        var href = $(event.currentTarget).attr('href');

        if (app.isCollectionAjaxed) {
          if (!search.length) {
            href += '?';
          }
          app._filterAjaxCall(href);
        } else {
          newURL = collectionHandle;
          if (selectedTags.length) {
            newURL += "/" + selectedTags.join('+');
          }
          delete Shopify.queryParams.page;
          search = $.param(Shopify.queryParams);
          if (search.length) {
            newURL += "?" + search;
          }
          location.href = newURL;
        }
      }

      // Tag filter
      if (filterType === 'tag') {
        $('[data-filter]:checked').each(function (i) {
          selectedTags.push(this.value);
        });

        app.collection.activeFilters = selectedTags;

        if (selectedTags.length) {
          Shopify.queryParams.constraint = selectedTags.join('+');
        } else {
          delete Shopify.queryParams.constraint;
        }

        if (app.isCollectionAjaxed) {
          app._filterAjaxCall();
        } else {
          delete Shopify.queryParams.page;
          location.search = $.param(Shopify.queryParams).replace(/%2B/g, '+');
        }
      }

      // Sort filter
      if (filterType === 'sort') {
        var sortValue = $(event.currentTarget).val();

        if (sortValue) {
          Shopify.queryParams.sort_by = sortValue;
        } else {
          delete Shopify.queryParams.sort_by;
        }

        if (app.isCollectionAjaxed) {
          app._filterAjaxCall();
        } else {
          var _search = $.param(Shopify.queryParams);
          if (_search.length) {
            location.search = $.param(Shopify.queryParams);
          } else {
            location.href = location.pathname;
          }
        }
      }

      // Collection pagination
      if (filterType === 'pagination') {
        var url = $(event.currentTarget).attr('href').match(/page=\d+/g);
        Shopify.queryParams.page = parseInt(url[0].match(/\d+/g), 10);

        if (url && (Shopify.queryParams.page === parseInt(url[0].match(/\d+/g), 10), Shopify.queryParams.page)) {
          if (app.isCollectionAjaxed) {
            url = app._filtersCreateUrl();
            history.push(url, {
              param: Shopify.queryParams
            });
            app._getNewTitle(Shopify.queryParams);
            app._getCollFilteredProducts(url);
          }
        }
      }

      // map all filters
      app._mapFilters();
    },


    /**
     * Get all parameters from URL and map them to all inputs in page
     *
     */
    _mapFilters: function _mapFilters() {
      // Read url parameters and map keys to filters
      if (location.search.length) {
        for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i += 1) {
          aKeyValue = aCouples[i].split('=');
          if (aKeyValue.length > 1) {
            Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
          }
        }
      }

      // sorting: select value
      if (Shopify.queryParams.sort_by) {
        $('[data-filter-sort]').val(Shopify.queryParams.sort_by);
      } else {
        $('data-filter-sort').val('manual');
      }

      // tags: select values
      if (Shopify.queryParams.constraint) {
        var selectedTags = [];
        $.each(Shopify.queryParams.constraint.split('+'), function (i, val) {
          if (val) {
            selectedTags.push(val);
          }
        });

        app.collection.activeFilters = selectedTags;
      }
    },
    _filtersCreateUrl: function _filtersCreateUrl(e) {
      var b = $.param(Shopify.queryParams).replace(/%2B/g, '+');
      return e ? b !== '' ? e + "?" + b : e : location.pathname + "?" + b;
    },
    _filterAjaxCall: function _filterAjaxCall(e) {
      delete Shopify.queryParams.page;
      var url = app._filtersCreateUrl(e);
      history.push(url, {
        param: Shopify.queryParams
      });
      app._getNewTitle(Shopify.queryParams);
      app._getCollFilteredProducts(url);
    },
    _urlParams: function _urlParams() {
      if (Shopify.queryParams === {}, location.search.length) {
        for (var i, e = 0, t = location.search.substr(1).split('&'); e < t.length; e += 1) {
          i = t[e].split('='), i.length > 1 && (Shopify.queryParams[decodeURIComponent(i[0])] = decodeURIComponent(i[1]));
        }
      }
    },
    _getNewTitle: function _getNewTitle(queryParams) {
      var tagParams = '';
      var pageParams = '';
      var finalParams = '';
      var title = document.title;
      var collection = title.slice(0, title.indexOf('-')).replace(/\s/g, '');
      var siteTitle = title.slice(title.lastIndexOf('-') + 1).replace(/\s/g, '');

      if (queryParams.constraint) {
        tagParams = " - Tagged \"" + queryParams.constraint.replace(/\+/g, ', ') + "\"";
      }

      if (queryParams.page) {
        pageParams = " - Page " + queryParams.page;
      }

      finalParams = "" + tagParams + pageParams;
      var newTitle = "" + collection + finalParams + " - " + siteTitle;
      document.title = newTitle;
    },
    _clearAllFilters: function _clearAllFilters() {
      delete Shopify.queryParams.constraint;
      delete Shopify.queryParams.q;
      app.collection.activeFilters = [];

      if (app.isCollectionAjaxed) {
        $('[data-filter]').attr('checked', false);
        app._filterAjaxCall();
      } else {
        location.search = $.param(Shopify.queryParams);
      }
    },
    _getCollFilteredProducts: function _getCollFilteredProducts(url) {
      if (Shopify.designMode) {
        return;
      }

      var limit = $('[data-template="collection"]').data('pagination-limit');
      var search = $.param(Shopify.queryParams);
      app.collection.products = [];
      app.collection.hawkpagination = {};
      app.isLoading = true;

      url += search.length ? '&view=products.json' : 'view=products.json';

      // for Shopify theme editor
      if (Shopify.designMode) {
        url = "/admin/products.json?limit=" + limit;
      }

      axios.get(url).then(function (response) {
        app.isLoading = false;
        var productsData = [];

        response.data.products.forEach(function (item) {
          var product = item.product;

          // add default current_variant object
          product.current_variant = product.variants[0];

          // add product options
          product.options_with_values = item.options_with_values;

          // add cart limit tag
          product.tags.forEach(function (tag) {
            if (tag.match('cart-limit')) {
              var cartLimit = tag.replace('cart-limit-', '');
              product.cart_limit = parseFloat(cartLimit);
            }
          });

          // exclude products that have the app.productExcludeTag (theme settings)
          if (product.tags.indexOf(app.productExcludeTag) === -1) {
            productsData.push(product);
          }
        });

        app.collection.products = productsData;
        app._getcollectionPagination(url);

        // reinitialize product reviews for each grid item
        app._getCollectionReviews();

        // reinitialize tooltips but only for desktop
        if (!detectIt.hasTouch) {
          setTimeout(function () {
            $('[data-toggle="tooltip"]').tooltip();
          }, 100);
        }

        $('html').animate({
          scrollTop: $('html').offset().top
        }, 400);
        // unlock window - fix scrolltop common problem
        $(window).bind('mousewheel', function () {
          $('html').stop();
        });
        return response;
      }).catch(function (error) {
        throw error;
      });
    },
    _getcollectionInfo: function _getcollectionInfo() {
      var url = window.location.href.replace(window.location.search, '');
      url += '?view=json';

      axios.get(url).then(function (response) {
        if (response.data) {
          app.collection.title = response.data.title;
          app.collection.description = response.data.body_html;
          app.collection.image = response.data.image;
          app.collection.handle = response.data.handle;
        }
        return response;
      }).catch(function (error) {
        throw error;
      });
    },
    _getcollectionPagination: function _getcollectionPagination(url) {
      url += '&view=paginate.json';

      axios.get(url).then(function (response) {
        app.collection.pagination = response.data;
        return response;
      }).catch(function (error) {
        throw error;
      });
    },
    _loadMore: function _loadMore(event) {
      var url = $(event.currentTarget).attr('href');
      url = url.replace('paginate', 'products');
      app.isLoading = true;

      axios.get(url).then(function (response) {
        $.each(response.data, function (key, item) {
          item.current_variant = item.variants[0];

          // exclude products that have the app.productExcludeTag (theme settings)
          if (item.tags.indexOf(app.productExcludeTag) === -1) {
            app.collection.products.push(item);
          }
        });

        app.isLoading = false;
        app._getcollectionPagination(url);
        return response;
      }).catch(function (error) {
        throw error;
      });
    },
    _hawkCompare: function _hawkCompare(event) {
      var imgUrl = '';
      var productId = {};
      var id = $(event.target).val();
      imgUrl = $(event.target).data('img');
      productId.id = id;
      productId.image = imgUrl;
      if ($(event.target).is(':checked')) {
        if (app.collection.compareProducts.length >= 5) {
          alert('You can compare up to 5 items');
          $(event.target).prop('checked', false).trigger('change');
        } else {
          app.collection.compareProducts.push(productId);
        }
      } else {
        app.collection.compareProducts = jQuery.grep(app.collection.compareProducts, function (value) {
          return value.id != productId.id;
        });
      }

      app.collection.compareProducts.forEach(function (comitem, index) {
        $(".hawk-compare-ul li:eq(" + index + ")").html("<img src=\"" + comitem.image + "\" data-productId=\"" + comitem.id + "\" style=\"width: 32px;\"/>");
      });

      return false;
    },
    _uncheckedProducts: function _uncheckedProducts(event) {
      var imgProductId = '';
      var inputProductId = '';
      imgProductId = $(event.target).attr('data-productId');
      $('[data-productDiv]').each(function () {
        inputProductId = $(this).find("input[type='checkbox']").attr('data-compare');
        if (imgProductId == inputProductId) {
          $(this).find("input[type='checkbox']").prop('checked', false);
          app.collection.compareProducts = app.collection.compareProducts.filter(function (item) {
            return item.id !== imgProductId;
          });
        }
      });
      $('.hawk-compare-ul li').each(function () {
        // eslint-disable-next-line shopify/jquery-dollar-sign-reference
        var e = $(this).find("img[data-productid='" + imgProductId + "']").parent();
        e.parent().append('<li>&nbsp;</li>'), e.remove();
      });
    },
    _compareProducts: function _compareProducts(event) {
      var $this = $(event.currentTarget);
      var id = '';
      app.collection.compareProducts.forEach(function (item) {
        var temp = item.id + ",";
        id += temp;
      });
      if (app.collection.compareProducts.length === 1) {
        alert('you should select at least 2 items');
        app.collection.showModal = false;
      } else {
        app.collection.showModal = true;
      }
      $.ajax({
        type: 'GET',
        url: "http://lusearchapi-na.hawksearch.com/sites/kitchencenter/?fn=compare&Items=" + id,
        beforeSend: function beforeSend() {
          $this.html('<span class="spinner-border spinner-border-sm mx-3" role="status" aria-hidden="true"></span>');
        },
        success: function success(data) {
          $('.modal-body').html(data);
          $('#modalCompare').modal('show');
          $this.html('Comparar');
        }
      });
    }
  }
};

export default collectionMethods;